// @ts-nocheck
import React, { useState } from "react";
import axios from 'axios';
import { Modal, Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useBody } from "../../Body/state/BodyContext";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import { useAlias } from "../State/AliasContext";
import { RUTA_API_ALIAS } from "../../Contantes/Constantes";

const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    boxShadow: 24,
    padding: '25px',
    width: 420,
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
        width: '85%',
    },
}));

export const DeleteAlias = ({ open, onClose }) => {
    const { setMessage, setSuccess } = useBody();
    const { aliases, setAliases, alias } = useAlias();
    const axiosInstance = setupInterceptorsTo(axios.create());
    const [loading, setLoading] = useState(false);

    const handleEliminar = async () => {
        setLoading(true);
        try {
            await axiosInstance.delete(RUTA_API_ALIAS, { data: { nombre: alias.nombre } });
            setAliases(aliases.filter((a) => a.mail !== alias.mail));
            setSuccess(`El alias ${alias.mail} fue eliminado correctamente.`);
            onClose();
        } catch {
            setMessage(`Hubo un error al querer eliminar el alias ${alias.mail}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Root>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <DeleteOutlineIcon color="error" />
                        <Typography variant="h6">Eliminar alias</Typography>
                    </Box>

                    <Typography variant="body1" color="text.secondary">
                        ¿Seguro que querés eliminar <strong>{alias?.mail}</strong>? Esta acción no puede revertirse.
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={onClose} disabled={loading}>
                            Cancelar
                        </Button>
                        <Button
                            sx={{ textTransform: 'none' }}
                            variant="contained"
                            color="error"
                            disabled={loading}
                            onClick={handleEliminar}
                        >
                            {loading ? 'Eliminando...' : 'Eliminar'}
                        </Button>
                    </Box>
                </Box>
            </Root>
        </Modal>
    );
};
